import { Button } from "@nextui-org/button";
import Link from "next/link";
import { IoChevronForward } from "react-icons/io5";
import ListItemDocument from "@/app/components/ListItemDocument";

export function AuthorDocumentsList({ docs, authorId }) {
  // Mostrar solo si hay documentos
  if (!docs || docs.length === 0) {
    return null;
  }
  return (
    <div className="mt-5 shadow-lg p-5 text-left">
      <h2 className="text-2xl font-bold text-blue-700 ">
        Publicaciones del autor
      </h2>
      <hr className="border-b border-gray-300 my-4 w-1/6" />
      <ul>
        {docs.map((doc) => (
          <ListItemDocument
            key={doc.id}
            doc={doc}
            path={`/document/${doc.id}`}
          />
        ))}
      </ul>
      <div className="flex flex-row-reverse mt-5">
        <Button
          color="primary"
          variant="solid"
          className="capitalize"
          endContent={<IoChevronForward />}
        >
          <Link href={`./${authorId}/documents`}>Más documentos</Link>
        </Button>
      </div>
    </div>
  );
}
